import { IAccordionData } from "@/models/IAccordionData";
import s1Icon1 from "../../assets/icons/capabilities-cmc-s1-1.png";
import s1Icon2 from "../../assets/icons/capabilities-cmc-s1-2.png";
import s1Icon3 from "../../assets/icons/capabilities-cmc-s1-3.png";
import s1Icon4 from "../../assets/icons/capabilities-cmc-s1-4.png";
import CapabilitiesTextContainer from "../../components/capabilitiesTextContainer";
import AccordionWrapper from "../../components/accordionWrapper";

const accordionDataRaw = [
  {
    header: "Chemistry, Manufacturing & Control",
    description:
      "Chemistry, Manufacturing & Control (CMC) support, from procurement through delivery of material to the clinic",
    data: [
      {
        headerSection: "",
        icon: (
          <img
            src={s1Icon1}
            alt="A drug substance in a beaker"
            className="h-24"
          />
        ),
        header: "Drug Substance",
        data: "Technical oversight of drug substance process development and manufacturing for small molecules, biologics, peptides and oligonucleotides",
      },
      {
        headerSection: "",
        icon: <img src={s1Icon2} alt="Three pills" className="h-24" />,
        header: "Drug Product",
        data: "Development and manufacturing expertise for a wide range of dosage forms, including solid orals, spray dried dispersions, sterile solutions and lyophilized solids",
      },
      {
        headerSection: "",
        icon: <img src={s1Icon3} alt="a building" className="h-24" />,
        header: "Regulatory Support",
        data: "Regulatory strategy consulting and submission support, including authoring and regulatory authority interactions support",
      },
      {
        headerSection: "",
        icon: (
          <img
            src={s1Icon4}
            alt="A beaker and other materials"
            className="h-24"
          />
        ),
        header: "Supply Planning & Clinical Packaging",
        data: "Supply chain and logistics support, from supply planning through clinical packaging, labeling and distribution",
      },
    ],
  },
];
const Cmc = (props: {
  accordionOpenHeader: string;
  setAccordionOpenHeader: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const accordionData: IAccordionData[] = [
    //CMC
    {
      header: accordionDataRaw[0].header,
      body: (
        <div className="px-4 py-4">
          <div className="text-xl font-light max-w-[40rem]">
            {accordionDataRaw[0].description}
          </div>
          <div className="my-8 grid xl:grid-cols-4 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            {accordionDataRaw[0].data.map((el, index) => (
              <div className="h-full">
                <CapabilitiesTextContainer>
                  <div>
                    <div className="w-full mt-2 mb-4 flex justify-center">
                      {el.icon}
                    </div>
                    <div className="font-medium mb-2">{el.header}</div>
                    <div>{el.data}</div>
                  </div>
                </CapabilitiesTextContainer>
              </div>
            ))}
          </div>
        </div>
      ),
    },
  ];
  return (
    <AccordionWrapper
      data={accordionData}
      setOpen={props.setAccordionOpenHeader}
      accordionOpenHeader={props.accordionOpenHeader}
    />
  );
};

export default Cmc;
